import { render, staticRenderFns } from "./Apk.vue?vue&type=template&id=271e0cc6&scoped=true&"
import script from "./Apk.vue?vue&type=script&lang=js&"
export * from "./Apk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271e0cc6",
  null
  
)

export default component.exports